module.exports = __webpack_public_path__ + "static/media/weathericon.bea38db3.png";